'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CHATFLOW = exports.CHATFLOW = 'CHATFLOW';
var ENTRY_URL = exports.ENTRY_URL = 'ENTRY_URL';
var CUSTOM = exports.CUSTOM = 'CUSTOM';
var CONTEXT_TYPE_ID = exports.CONTEXT_TYPE_ID = '@type';
var FORM = exports.FORM = 'FORM';
var CONNECTED_ACCOUNT = exports.CONNECTED_ACCOUNT = 'CONNECTED_ACCOUNT';